<template>
    <base-spinner :open="isFetching"></base-spinner>
    <div class="site__body">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">                    
                <div class="block-header__body">						
                    <div class="flexbox-page-info-container">
                        <div class="flex-item-page-info-breadcrumbs">
                            <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb-bottom-adjust" aria-label="breadcrumb">
                                <ol class="breadcrumb__list">
                                    <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                    <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                        <router-link to="/" class="breadcrumb__item-link">Home</router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--parent">
                                        <router-link to="/kit-catalog" class="breadcrumb__item-link">Engine Kits</router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--parent">
                                        <router-link :to="'/keyword-search-results?search=' + $route.params.kitnumber " class="breadcrumb__item-link">Kit Order</router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                                        <span class="breadcrumb__item-link">Engine Rebuild Kits</span>
                                    </li>  
                                    <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                </ol>
                            </nav>
                        </div>
                    <div class="flex-item-page-info-title">
                        <h1 class="block-header__breadcrumb-slim">Engine Rebuild Kit - {{product.desc}}</h1>
                    </div>
                    </div>		  							
                </div>
            </div>
        </div>	

        <div class="container container-align-top">
            <div class="row">		 
                <div class="flexbox-container--vehicle-selection-form">	

                    <div class="container">        
                        <!-- kit info -->
                        <kit-info :product="product" @addToCart="addToCart" :gtotal="gtotal + optTotal"></kit-info>

                        <!-- product list -->
                        <product-list 
                            v-if="!isFetching"
                            :kit_items="main_products" 
                            :isAddToCart="kitToCart"
                            :kitqty="kitqty"
                            :kit_info="product"
                            :optional_items="optional_items"
                            @addedToCart="kitToCart = false" 
                            @count_total="count_total">
                        </product-list>

                        <!-- <div class="block-space block-space--layout--divider-15"></div> -->
                        <!-- optionals -->
                        <!-- <optionals v-if="optional_items.length > 0 && !isFetching" 
                            :optionals="optional_items"
                            :substitutes="subs_items" 
                            @opt_total="opt_total">
                        </optionals> -->
                    </div>
                </div>
            </div>
        </div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>	

    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>

    <!-- site__body / end -->

    <!-- site__footer / end -->
    </div>
</template>

<script>
import KitInfo from './KitInfo.vue';
import ProductList from './ProductList.vue';
// import Optionals from './Optionals.vue';
import MXProduct from '../../../mixins/product';
import axiosvl from "../../../axios/axios-vl.js";
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';

export default {
    components: {KitInfo, ProductList},
    data() {
        return {
            product: {},
            kitToCart: false,
            kit_items: [],
            kit_sizes: [],
            subs_items: [],
            gtotal: 0,
            optTotal: 0,
            kitqty: 1,
            isFetching: true,
        };
    },
    mixins: [MXProduct],
    props: {
        manufacturer: {
            type: String,
        }
    },
    computed: {

        main_products(){
            // MAIN PRODUCTS ON THE LIST SHOULD BE
            // INFO is blank or OPTIONAL AND REQUIRED QTY IS > 0
            const main_products = this.kit_items.filter(k => k.info != 'SUBSTITUTE' && k.req_qty > 0);

            // console.log(main_products);
            return main_products;
        },

        optional_items() {
            const optionals = this.kit_items.filter(k => (k.req_qty == 0 && k.info != 'SUBSTITUTE'));
            // console.log(optionals.length);
            return optionals;
        },

        // subs_items() {
        //     return this.kit_items.filter(k => k.info == 'SUBSTITUTE');
        // }
    },
    methods: {
        getProductDetails(){
            this.mx_product_details(this.$route.params.manufacturer, this.$route.params.kitnumber).then(response => {
                console.log(response);
                this.product = response;
            });
        },
        
        addToCart() {
            this.kitToCart = true;
        },

        async fetchKitInfo() {
            await axiosvl.post(this.$store.getters['api/kit_master_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "KMMMFG": { "value": this.$route.params.manufacturer },
                        "KMMITM": { "value": this.$route.params.kitnumber },
                    },
                }
            })
            .then((response) => {
                this.isFetching = false;
                const fields = response.data.webroutine.fields;
                const KITPARTS = response.data.webroutine.lists.KITPARTS.entries;
                const MPARTS = response.data.webroutine.lists.MPARTS.entries;
                const ITMSIZES = response.data.webroutine.lists.ITMSIZES.entries;
                const PARTLOC = response.data.webroutine.lists.PARTLOC.entries;

                // console.table(PARTLOC);
                // const MPARTS = response.data.webroutine.lists.MPARTS.entries;
                this.kit_sizes = ITMSIZES;
                let kitm_loc = PARTLOC.find(loc => (loc.EIITMC == this.$route.params.kitnumber && loc.EIMFGC == this.$route.params.manufacturer));

                if(kitm_loc == undefined || kitm_loc == null){
                    kitm_loc = {
                        LCNAME: '',
                        LCLOCC: '',
                        LCTAXC: '',
                    }
                }

                // console.log(kitm_loc);
                const clApi = new CloudinaryApi;
                clApi.item_sku = this.$route.params.kitnumber;
                clApi.manufacturer_code = this.$route.params.manufacturer;

                clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                    let kitm_image = '';
                    if(imgURL){
                        kitm_image = imgURL;
                    }else{
                        kitm_image = GCONST.IMAGE_PLACEHOLDER;
                    }
                    this.product = {
                        ID: this.$route.params.kitnumber,
                        item: this.$route.params.kitnumber,
                        desc: fields.KITDSC.value,
                        long_desc: fields.DDTXT0K.value + ' ' + fields.DDTXT1K.value + ' ' + fields.DDTXT2K.value + ' ' + fields.DDTXT3K.value + ' ' + fields.DDTXT4K.value + ' ' + fields.DDTXT5K.value + ' ' + fields.DDTXT6K.value + ' ' + fields.DDTXT7K.value + ' ' + fields.DDTXT8K.value + ' ' + fields.DDTXT9K.value,
                        manufacturer: this.$route.params.manufacturer,
                        manufacturername: '',
                        yourprice: fields.KITPRC.value,
                        corecharge: fields.KITCOR.value,
                        listprice: fields.KITLST.value,
                        carrier: '',

                        // locations
                        locationid: fields.CMDLOC.value,
                        locationname: kitm_loc.LCNAME,
                        locationcity: kitm_loc.LCLOCC,
                        locationstate: kitm_loc.LCTAXC,

                        XRITMC: '',
                        XRMFGC: '',
                        // xref_mfg_desc: (fields.XRMFGC.value != '') ? xref_mfg_desc.MFG_DESC : '',
                        IMIGSA: fields.KITIGSA.value,
                        IMISVALID: '',
                        image: kitm_image,
                    };
                    // console.log(this.product);
                });
                
                KITPARTS.forEach(kit => {
                    let sizes = ITMSIZES.filter(s => s.QITEMNUM == kit.EIITMC && s.QSIZEITM != '' && s.QMFR == kit.EIMFGC);

                    // added default size on the list
                    if(sizes.length > 0) {
                        // console.log(sizes);

                        const prependSize = [];
                        const defaultSize = {
                            EICORP: kit.EICORP,
                            EIEXCP: kit.EIEXCP,
                            EILSTP: kit.EILSTP,
                            EKSIZE: kit.EKSIZE,
                            IMDESC: kit.IMDESC,
                            QITEMNUM: kit.EIITMC,
                            QITEMSZ: kit.QITEMSZ,
                            QMFR: kit.EIMFGC,
                            QSIZE: kit.QSIZE,
                            QSIZEIL: kit.QSIZEIL,
                            QSIZEITM: kit.QSIZEITM,
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? kit.QTYAVL : kit.TOTOH,
                        };

                        prependSize.push(defaultSize);
                        sizes.forEach( s => {
                            const sizeinfo = MPARTS.find(m => m.EIITMC == s.QITEMSZ);
                            sizeinfo.IMDESC = s.IMDESC;
                            sizeinfo.QITEMNUM = s.QITEMNUM;
                            sizeinfo.QITEMSZ = s.QITEMSZ;
                            sizeinfo.QMFR = s.QMFR;
                            sizeinfo.QSIZE = s.QSIZE;
                            sizeinfo.QSIZEITM = s.QSIZEITM;
                            sizeinfo.stockquantity = (this.$store.getters.customerIndicator == 'B') ? sizeinfo.QTYAVL : sizeinfo.TOTOH,
                            // sizeinfo.QTYAVL = (this.$store.getters.customerIndicator == 'B') ? s.QTYAVL : s.TOTOH,
                            // console.log(sizeinfo);
                            prependSize.push(sizeinfo);
                        });

                        sizes = prependSize;
                        // console.table(prependSize);
                    }

                    const kitc_loc = PARTLOC.find(loc => (loc.EIITMC == kit.EIITMC && loc.EIMFGC == kit.EIMFGC));
                    // console.log(kitc_loc);
                    // add substitutes to the separate var array
                    if(kit.CINFO == 'SUBSTITUTE'){
                        // if availability = 0, do not include on the dialog box
                        if(kit.QTYAVL == 0 && kit.TOTOH == 0){
                            return;
                        }

                        this.subs_items.push({
                            info: kit.CINFO,
                            item: kit.EIITMC,
                            desc: kit.IMDESC,
                            manufacturer: kit.EIMFGC,
                            manufacturername: kit.MCNAME,

                            yourprice: kit.EIEXCP,
                            corecharge: kit.EICORP,
                            listprice: kit.EILSTP,

                            backorder: '',
                            req_qty: kit.KCRQTY,
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? kit.QTYAVL : kit.TOTOH,
                            carrier: '',

                            // locations
                            locationid: kitc_loc.ILLOC,
                            locationname: kitc_loc.LCNAME,
                            locationcity: kitc_loc.LCLOCC,
                            locationstate: kitc_loc.LCTAXC,
                            
                            XRITMC: kit.XRITMC,
                            XRMFGC: kit.XRMFGC,
                            IMIGSA: kit.IMIGSA,
                            IMISVALID: kit.IMISVALID,
                            KCSEQN: kit.KCSEQN,
                            EKKITF: 'C',
                            image: GCONST.IMAGE_PLACEHOLDER,

                            sizes: sizes,
                            alternatives: [],
                            origItem: '',
                        });
                        return;
                    }

                    const clearProductCode = encodeURIComponent(kit.MCNAME);

                    this.kit_items.push({
                        info: kit.CINFO,
                        item: kit.EIITMC,
                        desc: kit.IMDESC,
                        manufacturer: kit.EIMFGC,
                        manufacturername: kit.MCNAME,
                        mfgSeo: kit.IMDESC.replace(/ /g, "-"),
                        itemSeo: clearProductCode.replace(/ /g, "-"),

                        yourprice: kit.EIEXCP,
                        corecharge: kit.EICORP,
                        listprice: kit.EILSTP,

                        backorder: '',
                        req_qty: kit.KCRQTY,
                        stockquantity: (this.$store.getters.customerIndicator == 'B') ? kit.QTYAVL : kit.TOTOH,
                        carrier: '',

                        // locations
                        locationid: kitc_loc.ILLOC,
                        locationname: kitc_loc.LCNAME,
                        locationcity: kitc_loc.LCLOCC,
                        locationstate: kitc_loc.LCTAXC,
                        
                        XRITMC: kit.XRITMC,
                        XRMFGC: kit.XRMFGC,
                        IMIGSA: kit.IMIGSA,
                        IMISVALID: kit.IMISVALID,
                        KCSEQN: kit.KCSEQN,
                        EKKITF: 'C',
                        // image: GCONST.IMAGE_PLACEHOLDER,
                        image: null,

                        sizes: sizes,
                        alternatives: [],
                        origItem: '',
                        defaultItem: {}
                    });
                
                });

                // console.table(this.kit_items);

                this.kit_items.forEach(kit => {
                    const alternatives = this.subs_items.filter(k => k.KCSEQN == kit.KCSEQN );
                    alternatives.forEach(a => {
                        a.origItem = kit.item;
                    })
                    kit.alternatives = alternatives;
                    const clApi = new CloudinaryApi;
                    clApi.item_sku = kit.item;
                    clApi.manufacturer_code = kit.manufacturer;

                    clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                        kit.image = imgURL;
                        if(imgURL){
                            kit.image = imgURL;
                        }else{
                            kit.image = GCONST.IMAGE_PLACEHOLDER;
                        }
                    });
                });

                this.isFetching = false;

                // console.log(this.kit_items);
             })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        count_total(gtotal) {
            // console.log('gtotal KitGroup = ' + gtotal);
            this.gtotal = gtotal;
        },
    },
    mounted() {        
        this.fetchKitInfo();
        // this.getProductDetails();
    },
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
    }
}
</script>